export { customImageLoader as default } from '@edelman/storyblok-ui/src/utils/customImageLoader';
